import React, {useEffect, useRef, useState} from 'react';
import {HOST, JAVASCRIPT_VOID} from 'constants/config';
import {getModalAttribute} from 'lib/utils';
import {Info} from 'lib/api/vodInfo';
import {IWebEditorContents} from 'lib/api/setWebEditorJob';
import ModalPortal from 'ModalPortal';
import Save from 'components/common/modal/Save';
import Loading from 'components/common/modal/Loading';
import SaveContents from 'components/common/modal/SaveContents';
import Anchor from './Anchor';
import {t} from 'lib/i18n';

/**
 * 영상 제목/저장 컴포넌트
 */

interface ITitleProps {
  editMode: string;
  titleInfo: Info;
  modal: boolean;
  loading: boolean;
  webLoading: boolean;
  saveBtn: string;
  webEditSaveInfo: IWebEditorContents;
  setWebEditSaveInfo: React.Dispatch<React.SetStateAction<IWebEditorContents>>;
  onClickModal: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  onClickSaveCancel: () => void;
  onClickSave: () => void;
}

const Title = ({
  editMode,
  titleInfo,
  modal,
  loading,
  webLoading,
  saveBtn,
  webEditSaveInfo,
  setWebEditSaveInfo,
  onClickModal,
  onClickSaveCancel,
  onClickSave,
}: ITitleProps) => {
  const margin =
    editMode === 'section'
      ? '-103.5px 0px 0px -161.5px'
      : '-244px 0px 0px -241px';
  const [marginState, setMarginState] = useState(margin);
  const popupWrapRef = useRef<HTMLDivElement | null>(null);
  const WEB_EDITOR_HELP_URL = HOST.BJ_AFREECATV + '/afvodtv/post/51987760';
  const HELP_URL = HOST.BJ_AFREECATV + '/afvodtv/post/58472424';

  /**
   * 영상 저장 시 div 너비/높이 값 재지정
   */
  useEffect(() => {
    if (!popupWrapRef.current) return;

    const {width, height} = getModalAttribute(popupWrapRef.current);

    setMarginState(`-${height}px 0px 0px -${width}px`);
  }, [modal]);

  return (
    <div className='title'>
      <h2>{titleInfo.title_name}</h2>
      <Anchor
        classNaming='howToUse'
        url={editMode === 'section' ? WEB_EDITOR_HELP_URL : HELP_URL}
        title={t('사용방법')}
        targetType='_blank'>
        {editMode === 'section' ? t('VOD 구간 편집') : t('편집 VOD 만들기')}
      </Anchor>
      <a className={saveBtn} href={JAVASCRIPT_VOID} onClick={onClickModal}>
        {editMode === 'section' ? t('영상 저장') : t('영상 만들기')}
      </a>
      {webLoading && (
        <ModalPortal>
          <Loading />
        </ModalPortal>
      )}
      {modal && (
        <ModalPortal>
          {loading && <Loading />}
          {editMode === 'section' && (
            <Save
              marginState={marginState}
              popupWrapRef={popupWrapRef}
              onClickSaveCancel={onClickSaveCancel}
              onClickSave={onClickSave}
            />
          )}
          {editMode === 'web' && (
            <SaveContents
              marginState={marginState}
              popupWrapRef={popupWrapRef}
              bbsInfo={titleInfo.bbs}
              langs={titleInfo.langs}
              webEditSaveInfo={webEditSaveInfo}
              setWebEditSaveInfo={setWebEditSaveInfo}
              onClickSaveCancel={onClickSaveCancel}
              onClickSave={onClickSave}
            />
          )}
        </ModalPortal>
      )}
    </div>
  );
};

export default Title;
